/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './posterMatrix.scss';
import { Col, Container, Row } from 'react-bootstrap';
import GridPanel from '../../molecules/gridPanel/gridPanel';
import Button, { ButtonSize, ButtonTheme, ButtonType } from '../../atoms/button/button';
import PreviewPosterMatrix from '../previewPosterMatrixModal/previewPosterMatrixModal';

const PosterMatrix = (props) => {
  const {
    configFile,
    onChange,
    value
  } = props;

  const [board, setBoard] = useState({0:[], 1:[], 2:[]})
  const [first, setFirstPanel] = useState([])
  const [second, setSecondPanel] = useState([])
  const [third, setThirdPanel] = useState([])
  const [fourth, setFourthPanel] = useState([])
  const [fifth, setFifthPanel] = useState([])
  const [openPreview, setOpenPreview] = useState(false);

  const handleOnChange = (array, placement) => {
    switch(placement){
      case 0:
        setFirstPanel(array)
        break;
      case 1:
        setSecondPanel(array)
        break;
      case 2:
        setThirdPanel(array)
        break;
      case 3:
        setFourthPanel(array)
        break;
      case 4:
        setFifthPanel(array)
        break;
    }

    board[0]= first;
    board[1]= second
    board[2]= third
    board[3]= fourth
    board[4]= fifth
    board[placement] = array
    setBoard(board)   
    onChange(board)
  };

  const handleRemovePanel = (panel) => {
    let newBoard = {};
    Object.keys(board).forEach(element => {
        if(element < panel){
          newBoard[element] = board[element];
          return element
        } else if(element > panel){
          board[element].map(item => item.placement = item.placement-1)
          return newBoard[element - 1] = board[element];
        }
      });
    setBoard(newBoard)   
    onChange(newBoard)
  };

  const onClickOpenPreview = () => {
    setOpenPreview(!openPreview);
  };

  const onClickAddPanel = () => {
    board[Object.keys(board).length] = []
    setBoard({...board})
  };

  useEffect(()=>{
    if(value !== undefined && value.length > 0){
        setFirstPanel(value.filter(item=> item["placement"] == 0))
        setSecondPanel(value.filter(item=> item["placement"] == 1))
        setThirdPanel(value.filter(item=> item["placement"] == 2))
        setFourthPanel(value.filter(item=> item["placement"] == 3))
        setFifthPanel(value.filter(item=> item["placement"] == 4))
    }  else if(value == undefined) {
      setFirstPanel([])
      setSecondPanel([])
      setThirdPanel([])
      setFourthPanel([])
      setFifthPanel([])
      setBoard({0:[], 1:[], 2:[]})
    }
  },[value])
  useEffect(()=>{
        setBoard({
                    0:first, 
                    1:second, 
                    2:third, 
                    ...(fourth.length > 0 || fifth.length > 0) && {3: fourth},
                    ...(fifth.length > 0) && {4: fifth},
                  })
  },[first, second, third, fourth, fifth])

  return (
    <div>
      <Container fluid>
        { Object.keys(board).length < 5
          && (
            <Button  
                id={'add-panel'}
                type={ButtonType.BUTTON} 
                theme={ButtonTheme.INFO} 
                onClick={onClickAddPanel}
              >{'Add Panel'}
            </Button>
        )}
        <Row className='grid-row'>
          {(Object.keys(board).map((panel, index) => (
              <Col className="grid-column" key={index}>
                <GridPanel 
                  key={"sports-room-panel-"+index}
                  configFile={configFile}
                  placement={index}
                  value={board[index]}
                  onRemovePanel={handleRemovePanel}
                  onChange={(array)=> handleOnChange(array, index)} 
                ></GridPanel>
              </Col>
          )))}
        </Row>   
        <div className='preview-button'>
          <Button  
            type={ButtonType.BUTTON} 
            theme={ButtonTheme.INFO} 
            onClick={onClickOpenPreview}
          >{openPreview ? 'Close Preview' : 'Open Preview'}</Button>
        </div>
        { openPreview
          && (
            <PreviewPosterMatrix
              title={`Load Poster Matrix`}
              configFile={configFile}
              data={board}
            ></PreviewPosterMatrix>
          )}
      </Container>
    </div>
  );
};

PosterMatrix.propTypes = {
    /**
   * Data set change event
   */
     onChange: PropTypes.func,
};

PosterMatrix.defaultProps = {
  onChange: () => {},
};

export default PosterMatrix;
